export interface BuildFlowPathOptions {
  flowName: string;
  courseId?: number | null;
  targetDate?: string | null;
  flowRunId?: number | null;
}

const isValidCourseId = (value: number | null | undefined): value is number =>
  typeof value === 'number' && Number.isFinite(value) && value > 0;

export const buildFlowPath = ({
  flowName,
  courseId,
  targetDate,
  flowRunId,
}: BuildFlowPathOptions): string => {
  const encodedFlowName = encodeURIComponent(flowName);
  const basePath = isValidCourseId(courseId)
    ? `/courses/${courseId}/flows/${encodedFlowName}`
    : `/flows/${encodedFlowName}`;

  const searchParams = new URLSearchParams();
  if (targetDate) {
    searchParams.set('targetDate', targetDate);
  }
  if (typeof flowRunId === 'number' && Number.isFinite(flowRunId)) {
    searchParams.set('flowRunId', String(flowRunId));
  }

  const search = searchParams.toString();
  return search ? `${basePath}?${search}` : basePath;
};
